import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const PageContainer = styled(WideContainer)`
    flex-direction: column;
    row-gap: 60px;
    margin-top: 72px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-top: 60px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-top: 24px;
    }
`;
